import { IssueActualInvoiceMain } from './IssueActualInvoiceMain'
import { IssueProformaInvoiceMain } from './IssueProformaInvoiceMain'
import { ProformaInvoicesDetail } from './ProformaInvoices/ProformaInvoicesDetail/ProformaInvoicesDetail'
import { ProformaInvoicesForm } from './ProformaInvoices/ProformaInvoicesForm/ProformaInvoicesForm'
import { ProformaInvoicesMain } from './ProformaInvoicesMain'
import React from 'react'

const arProformaInvoicesRoutes = [
  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/proforma-invoices/proforma-invoice-requisition',
    },
    component: <ProformaInvoicesMain />,
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/proforma-invoices/issue-proforma-invoice',
    },
    component: <IssueProformaInvoiceMain />,
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/proforma-invoices/issue-actual-invoice',
    },
    component: <IssueActualInvoiceMain />,
  },
  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/proforma-invoices/:ProformaSubmenu/add',
    },
    component: <ProformaInvoicesForm formMode="add" formLabel="New" />,
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/proforma-invoices/:ProformaSubmenu/:ProformaRequisitionID/edit',
    },
    component: <ProformaInvoicesForm formMode="edit" formLabel="Edit" />,
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/proforma-invoices/:ProformaSubmenu/:ProformaRequisitionID/resubmit',
    },
    component: (
      <ProformaInvoicesForm formMode="resubmit" formLabel="Resubmit" />
    ),
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/proforma-invoices/proforma-invoice-requisition/:ProformaRequisitionID/detail',
    },
    component: (
      <ProformaInvoicesDetail
        routeSegments="Proforma Invoice Requisition"
        submenu="proforma-invoice-requisition"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/proforma-invoices/issue-proforma-invoice/:ProformaRequisitionID/detail',
    },
    component: (
      <ProformaInvoicesDetail
        routeSegments="Issue Proforma Invoice"
        submenu="issue-proforma-invoice"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/proforma-invoices/issue-actual-invoice/:ProformaRequisitionID/detail',
    },
    component: (
      <ProformaInvoicesDetail
        routeSegments="Issue Actual Invoice"
        submenu="issue-actual-invoice"
      />
    ),
  },
]

export default arProformaInvoicesRoutes
